import { PopupDownloadComponent } from './popup-download.component';

export default angular
  .module('sfMobile.components.popup-download', [
    'sfMobile.components.progressBar',
  ])
  .component('sfPopupDownload', PopupDownloadComponent).name;
